import { type PropsWithChildren } from 'react';

import { Heading } from '@backyard-ui/core';

import { styles } from './MapTitle.styles';

export default function MapTitle(props: Readonly<PropsWithChildren>) {
  const { children } = props;

  return (
    <Heading size="4xl" asChild>
      <h1 className={styles()}>{children}</h1>
    </Heading>
  );
}
